import React, { useRef, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import debounce from 'lodash/debounce';

const withGetchDataHOCGenerator = (Component) => {
  function WithGetchDataHOC(props) {
    const { debounceDelay, query, getData, closeDropdownAndResetMatches, openDropdownWithMatches, autosuggestOnSelect } = props;
    const mountedRef = useRef(false);

    useEffect(() => {
      mountedRef.current = true;
      return () => {
        mountedRef.current = false;
      };
    }, []);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const getchDataDebounced = useCallback(
      debounce(async (_query, _getData) => {
        const matches = await _getData(_query);

        if (!mountedRef.current) {
          return;
        }

        if (isEmpty(matches)) {
          closeDropdownAndResetMatches();
        } else if (matches.length === 1 && matches[0]?.title === _query) {
          openDropdownWithMatches(matches);
          autosuggestOnSelect(0);
        } else {
          openDropdownWithMatches(matches);
        }
      }, debounceDelay),
      [debounceDelay]
    );

    useEffect(() => {
      if (query) {
        getchDataDebounced(query, getData);
      } else {
        closeDropdownAndResetMatches();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [query]);

    return <Component {...props} />;
  }

  WithGetchDataHOC.propTypes = {
    debounceDelay: PropTypes.number,
    query: PropTypes.string,
    getData: PropTypes.func,
    closeDropdownAndResetMatches: PropTypes.func,
    openDropdownWithMatches: PropTypes.func,
    autosuggestOnSelect: PropTypes.func,
  };

  return WithGetchDataHOC;
};

const withGetchData = () => (Component) => withGetchDataHOCGenerator(Component);

export default withGetchData;
